import React from "react";
import { PopupButton } from "react-calendly";
import "./more-info.scss";

const ctas = [
  {
    subtext: "Book a consultation to hear how we've helped others, and how we can help you."
  },
  {
    subtext: "Let's talk about how we've helped others succeed, and how we can support you too."
  },
  {
    subtext: "Find out how we've supported teams like yours, and what we can do together."
  },
  {
    subtext: "See how we’ve helped brands and agencies scale, and how we can support you too."
  },
  {
    subtext: "Book a consultation and hear how we support teams just like yours."
  }
];

// Randomly select one CTA on render
const randomCta = ctas[Math.floor(Math.random() * ctas.length)];

export default function ConsultationSection({ backgroundColorGrey = false }: { backgroundColorGrey?: boolean }) {
  return (
    <section
      id="consultation"
      className="p-4 pb-10 pt-6 lg:pt-8 lg:pb-12 bg-gray-100 border-t border-gray-200"
    >
      <div className="text-center mt-4 mb-2 leading-[1.2]">
        <h2 className="text-lg lg:text-2xl font-bold mb-2 mx-auto">Get in Touch</h2>
        <p>{randomCta.subtext}</p>
      </div>

      <div className="text-center flex flex-col md:flex-row justify-center items-center mt-6 gap-0 md:gap-4">
        {typeof window !== "undefined" ? (
          <PopupButton
            className="btn text-hamariBlue cursor-pointer font-bold text-base bg-[#ffb74d] rounded-none red-yellow-animate w-full md:w-auto"
            url="https://calendly.com/fareed-patel"
            text="Book"
            rootElement={document.getElementById("___gatsby") as HTMLElement}
          />
        ) : null}
        <div className="text-sm my-4">Or</div>
        <a
          href="mailto:contact@hamari.agency"
          className="email-us font-bold lg:my-4 animate-underline w-full md:w-auto"
        >
          Email us
        </a>
      </div>
    </section>
  );
}
